import { css } from '@emotion/react';

/**
 * Global 적용 스타일
 */
const global = css`
	html {
		font-size: 10px;
		/* 모바일 폰트 사이즈 자동 조절 문제 방지 */
		-webkit-text-size-adjust: none; /*Chrome, Safari, newer versions of Opera*/
		-moz-text-size-adjust: none; /*Firefox*/
		-ms-text-size-adjust: none; /*Ie*/
		-o-text-size-adjust: none; /*old versions of Opera*/
	}

	body {
		font-family: Pretendard, sans-serif;
		font-size: 16px;
		-webkit-font-smoothing: antialiased;
	}
	.wrapper {
		display: flex;
		min-height: 100vh;
		flex-direction: column;
	}
	.hidden {
		height: 100%;
		min-height: 100%;
		overflow: hidden;
		touch-action: none;
	}
	main {
		flex: 1;
	}
	footer {
		height: 100%;
		@media screen and (max-width: 768px) {
			height: 100%;
		}
	}
`;

export default global;
